import Artworks from 'modules/artworks';
// import WalletCheck from 'modules/common/components/wallet-check';
import ROUTES from 'modules/common/constants/route';
import Home from 'modules/home';
import MintNFT from 'modules/mint-nfts';
import MyArtworks from 'modules/my-artworks';
import Admin from 'modules/admin';
import AddAdmin from 'modules/add-admin';
import FAQWalletPage from 'modules/faq/wallet';
import FAQBuyPage from 'modules/faq/coins';
import FAQCreationPage from 'modules/faq/creation';
import FAQGasPage from 'modules/faq/gas';
import FAQSellPage from 'modules/faq/sell';
import PrivateRoute from './private-route';
import AdminRoute from './admin-route';
import MasterRoute from './master-route';

/**
 * Define the routeing structure using array. Here include the nested routeing as well.
 * And also define the auth wrapper and private routers for helping to role based routes
 */
const routes = [
  {
    path: ROUTES.ROOT,
    element: <Home />,
  },
  {
    path: ROUTES.MINT,
    element: <AdminRoute component={MintNFT} />,
  },
  {
    path: ROUTES.ARTWORKS,
    element: <Artworks />,
  },
  {
    path: ROUTES.MY_ARTWORKS,
    element: <PrivateRoute component={MyArtworks} />,
  },
  {
    path: ROUTES.ADMIN,
    element: <AdminRoute component={Admin} />,
  },
  {
    path: ROUTES.ADD_ADMIN,
    element: <MasterRoute component={AddAdmin} />,
  },
  {
    path: ROUTES.FAQ_WALLET,
    element: <FAQWalletPage />,
  },
  {
    path: ROUTES.FAQ_COIN,
    element: <FAQBuyPage />,
  },
  {
    path: ROUTES.FAQ_CREATION,
    element: <FAQCreationPage />,
  },
  {
    path: ROUTES.FAQ_GAS,
    element: <FAQGasPage />,
  },
  {
    path: ROUTES.FAQ_SELL,
    element: <FAQSellPage />,
  },
];
export default routes;
